export default __webpack_public_path__ + "static/media/img6.c86a2d2b.jpg";